import { LIMITS } from "@/constants/constants";
import InputSelect from "../input-select/InputSelect";
import { literals } from "@/constants/literals";

export const Limit = ({
  limit,
  setLimit,
}: {
  limit: string;
  setLimit: (newPage: string) => void;
}) => {
  return (
    <div data-testid="limits-test" className="flex items-center gap-3">
      <div>
        <p className="text-nowrap">{literals.pageElements}:</p>
      </div>
      <InputSelect
        size={"small"}
        value={limit}
        onChange={setLimit}
        options={LIMITS}
        id={"limit"}
      />
    </div>
  );
};
